import type { ChainArch } from "@opensea/graphql"
import { proxy, subscribe } from "valtio"
import { deepClone } from "valtio/utils"
import type { Address } from "../types"
import { persistStore, restoreStore } from "../utils/storeUtils"

// -- Helpers -------------------------------------------------------
const STORAGE_KEY = "opensea-wallet-previously-connected-accounts-store"
const STORAGE_VERSION = 1
const MAX_PREVIOUS_ACCOUNTS = 5

// -- Types ---------------------------------------------------------
export interface PreviousAccountType {
  address: Address
  chainId: number
  connectorId: string
  chainArch: ChainArch
}

type PreviousAccountsStateType = {
  storageVersion: typeof STORAGE_VERSION
  accounts: PreviousAccountType[]
}

// -- State ---------------------------------------------------------
const INITIAL_STATE: PreviousAccountsStateType = {
  storageVersion: STORAGE_VERSION,
  accounts: [],
}

export const PreviousAccountsState = proxy<PreviousAccountsStateType>(
  deepClone(INITIAL_STATE),
)

// -- Actions -------------------------------------------------------
export const PreviousAccountsActions = {
  rehydrate() {
    Object.assign(
      PreviousAccountsState,
      restoreStore(STORAGE_KEY, STORAGE_VERSION, INITIAL_STATE),
    )
  },

  addAccount(account: PreviousAccountType) {
    PreviousAccountsState.accounts = [
      account,
      ...PreviousAccountsState.accounts.filter(
        a => a.address !== account.address,
      ),
    ].slice(0, MAX_PREVIOUS_ACCOUNTS)
  },
}

// -- Subscribe -----------------------------------------------------
subscribe(PreviousAccountsState, () => {
  persistStore(STORAGE_KEY, PreviousAccountsState)
})
